import {
  CeleryIcon,
  OpensearchIcon,
  RabbitMQIcon,
  VictoriaMetricsIcon,
} from '@/shared/ui/icons';
import { RulesAccess, ACCESS_RULES_TREE } from '@/entities/user/access-rule';

import { ActionIcon, Group, Menu, ThemeIcon } from '@mantine/core';
import IconBellCog from '@tabler/icons-react/dist/esm/icons/IconBellCog.mjs';
import IconExternalLink from '@tabler/icons-react/dist/esm/icons/IconExternalLink.mjs';
import IconHelpSquareRounded from '@tabler/icons-react/dist/esm/icons/IconHelpSquareRounded.mjs';

export const ExternalLinks = () => {
  return (
    <RulesAccess
      rule={{
        list: [
          ACCESS_RULES_TREE.third_party_service.alertmanager.edit,
          ACCESS_RULES_TREE.third_party_service.flower.edit,
          ACCESS_RULES_TREE.third_party_service.os_dashboards.edit,
          ACCESS_RULES_TREE.third_party_service.rabbitmq.edit,
          ACCESS_RULES_TREE.third_party_service['metrics-agent'].edit,
          ACCESS_RULES_TREE.third_party_service['metrics-storage'].edit,
          ACCESS_RULES_TREE.third_party_service['metrics-ruler'].edit,
        ],
      }}
    >
      <Group data-testid='external-links-group' gap={'xs'} wrap='nowrap'>
        <ActionIcon
          variant={'light'}
          component='a'
          target='_blank'
          href='/docs'
        >
          <IconHelpSquareRounded size={20} />
        </ActionIcon>
        <Menu trigger='click-hover'>
          <Menu.Target>
            <ActionIcon variant={'light'}>
              <IconExternalLink size={20} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <RulesAccess
              rule={{
                list: [ACCESS_RULES_TREE.third_party_service.flower.edit],
              }}
            >
              <Menu.Item
                component='a'
                target='_blank'
                href='/flower'
                leftSection={
                  <ThemeIcon variant='transparent'>
                    <CeleryIcon size={24} />
                  </ThemeIcon>
                }
              >
                Celery
              </Menu.Item>
            </RulesAccess>

            {/*<Menu.Item
              component='a'
              target='_blank'
              href='/prometheus'
              leftSection={
                <ThemeIcon variant='transparent'>
                  <PrometheusIcon size={28} />
                </ThemeIcon>
              }
            >
              Prometheus
            </Menu.Item>*/}
            <RulesAccess
              rule={{
                list: [ACCESS_RULES_TREE.third_party_service.alertmanager.edit],
              }}
            >
              <Menu.Item
                component='a'
                target='_blank'
                href='/alertmanager'
                leftSection={
                  <ThemeIcon variant='transparent' color='#e64a19'>
                    <IconBellCog />
                  </ThemeIcon>
                }
              >
                Alertmanager
              </Menu.Item>
            </RulesAccess>
            <RulesAccess
              rule={{
                list: [
                  ACCESS_RULES_TREE.third_party_service.os_dashboards.edit,
                ],
              }}
            >
              <Menu.Item
                component='a'
                target='_blank'
                href='/os_dashboards'
                leftSection={
                  <ThemeIcon variant='transparent'>
                    <OpensearchIcon size={20} />
                  </ThemeIcon>
                }
              >
                Opensearch
              </Menu.Item>
            </RulesAccess>
            <RulesAccess
              rule={{
                list: [ACCESS_RULES_TREE.third_party_service.rabbitmq.edit],
              }}
            >
              <Menu.Item
                component='a'
                target='_blank'
                href='/rabbitmq'
                leftSection={
                  <ThemeIcon variant='transparent'>
                    <RabbitMQIcon size={24} />
                  </ThemeIcon>
                }
              >
                RabbitMQ
              </Menu.Item>
            </RulesAccess>
            <RulesAccess
              rule={{
                list: [
                  ACCESS_RULES_TREE.third_party_service['metrics-agent'].edit,
                  ACCESS_RULES_TREE.third_party_service['metrics-storage'].edit,
                  ACCESS_RULES_TREE.third_party_service['metrics-ruler'].edit,
                ],
              }}
            >
              <Menu.Sub position='bottom-end'>
                <Menu.Sub.Target>
                  <Menu.Sub.Item
                    leftSection={<VictoriaMetricsIcon size={20} />}
                  >
                    Victoria Metrics
                  </Menu.Sub.Item>
                </Menu.Sub.Target>

                <Menu.Sub.Dropdown>
                  <RulesAccess
                    rule={{
                      list: [
                        ACCESS_RULES_TREE.third_party_service['metrics-storage']
                          .edit,
                      ],
                    }}
                  >
                    <Menu.Item
                      component='a'
                      target='_blank'
                      href='/metrics-storage'
                    >
                      metrics-storage
                    </Menu.Item>
                  </RulesAccess>
                  <RulesAccess
                    rule={{
                      list: [
                        ACCESS_RULES_TREE.third_party_service['metrics-agent']
                          .edit,
                      ],
                    }}
                  >
                    <Menu.Item
                      component='a'
                      target='_blank'
                      href='/metrics-agent'
                    >
                      metrics-agent
                    </Menu.Item>
                  </RulesAccess>
                  <RulesAccess
                    rule={{
                      list: [
                        ACCESS_RULES_TREE.third_party_service['metrics-ruler']
                          .edit,
                      ],
                    }}
                  >
                    <Menu.Item
                      component='a'
                      target='_blank'
                      href='/metrics-ruler'
                    >
                      metrics-ruler
                    </Menu.Item>
                  </RulesAccess>
                </Menu.Sub.Dropdown>
              </Menu.Sub>
            </RulesAccess>
          </Menu.Dropdown>
        </Menu>
      </Group>
    </RulesAccess>
  );
};